export default {
  queue: {},
};
